import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSidebar } from "components/ui/sidebar";
import { motion } from "framer-motion";

export default function SidebarProfileDetails({ isTouchDevice = false }) {

    const navigate = useNavigate()

    const { open, animate, setOpen } = useSidebar();

    const userPicture = useSelector((state) => state.user.picture)
    const firstName = useSelector((state) => state.user.firstName)
    const lastName = useSelector((state) => state.user.lastName)
    
    const handleClick = () => {
        // If sidebar is open when clicking, persist that state
        if (open) {
            setOpen(true);
        }

        navigate('/user/profile');
    };
    
    if (isTouchDevice === true) {
        return (
            <div 
                className="my-2 flex flex-col items-center gap-0.5"
                onClick={handleClick}
            >
                <img 
                    src={userPicture} 
                    alt="Profile Pic" 
                    className="rounded-full h-10 w-10" 
                />

                <p className="text-center text-white text-xxs">Profile</p>
            </div>
        )
    }

    if (isTouchDevice === false) {
        return (
            <div 
                className="flex items-center justify-start gap-2 group/sidebar py-2 cursor-pointer"
                onClick={handleClick}
            >
                <img className="rounded-full h-7 w-7" src={userPicture} alt="Profile Pic" />

                <motion.span
                    initial={{
                        display: animate ? (open ? "inline-block" : "none") : "inline-block",
                        opacity: animate ? (open ? 1 : 0) : 1,
                    }}
                    animate={{
                        display: animate ? (open ? "inline-block" : "none") : "inline-block",
                        opacity: animate ? (open ? 1 : 0) : 1,
                    }}
                    className="text-neutral-200 text-sm group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0"
                >
                    {firstName} {lastName}
                </motion.span>
            </div>
        )
    }
}